import { vMaska } from "maska"

export default defineNuxtPlugin((nuxtApp) => {
  const maskDirective = {
    ...vMaska,
    getSSRProps() {
      return {}
    }
  }

  nuxtApp.vueApp.directive("maska", maskDirective)
  nuxtApp.vueApp.directive("mask", maskDirective)
})
